import classNames from 'classnames'
import * as React from 'react'
import { DragDropContext, DropResult } from 'react-beautiful-dnd'
import { useHistory } from 'react-router-dom'
import { Button, Checkbox, Input, Label, PortalContainer, ToggleFilter, eventDispatcher, useAlert, useToast } from 'uxp/components'
import { IContextProvider } from '../../uxp'
import { injectAtPath, IWidgetInstance, IWidgetTemplate, IWDDesignModeProps, IWidgetProps, IWidgetTemplateInstanceProps, IWidgetTemplateProps, SourceBrowser, getUserTemplateKeyFromId, extractModuleIdFromURL, } from '../common/common'
import { triggerDrop } from '../common/dnd'
import { getTag } from '../common/useTag'
import FieldPanel from './FieldPanel'
import GridLayout from "react-grid-layout";
import { UndoManager } from './undo-manager'
import IconEditor from '../common/icon-selector/IconEditor'
import PropertyPanel from './PropertyPanel'
import { ISelectableItemUIProp } from '../common/SelectableItem'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import BundleConfig from '../../../bundle.json'
import { CSSTransition } from 'react-transition-group';


import _ from 'lodash'

import './Designer.scss'
import { CustomColorPicker, Property, PropertyContainer, PropertyContainerSubTitle, PropertyContainerTitle, PropertyGroup, PropertyGroupTitle, PropertyTitle } from '../common/ui-props/common'
import { ImagePicker } from 'lucy/common-components'
import MobileFieldsPanel from './MobileFieldsPanel'
import { MobilePageLayout, IMobileNavigationTab, extractTabs } from './MobilePageLayout'
import { useEffect } from "react";
import WidgetPanel from './WidgetPanel'
import { MultipleDataSourceEditor } from '../common/MultipleDataSourceEditor'
import ActionEditorLink, { IAction } from '../common/action-editor/ActionEditor'
import { SortableList } from '../common/ui-fields/sortableList/SortableList'
import { WidgetParamsEditor } from '../common/WidgetParamsEditor'
import { bindContainerId, buildUrl, generateFullUUID, generateUUID, getRandomIcon, hasValue, isPromise, tryParseJSON } from '../../util'


const LocationOrigin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');

interface IMobileConfigurations {
    loginLogo: string,
    backgroundImage: string
    appBarHeight: string
    appBarBackgroundColor: string,
    appBarBackgroundImage: string,
    appBarText: string,
    appBarTextColor: string,
    logo: string
    backgroundColor: string
    backgroundColor2: string
    textColor: string
    bottomNavigationBarBackgroundColor: string
    bottomNavagationBarSelectedItemColor: string
    bottomNavigationBarUnselectedItemColor: string
    hideLucyLogo: string,
    appBarButtons: IAppBarButton[]
}
interface IDesignerProps {
    mode: IDesignerMode,
    onChangeMode: (mode: IDesignerMode) => void,
    uxpContext: IContextProvider,
    isNew: boolean,
    enableSave: (val: boolean) => void
    onModifiyContent: (val: boolean) => void
    template?: IWidgetTemplate,
    widget?: IWidgetInstance,
    modelKey: string,
    initialSource: string,
    sourceBrowser?: SourceBrowser,
    uiProps?: any
    templateId?: string,
    isMobile?: boolean,
    mobileConfigurations?: IMobileConfigurations,
}

export type IDesignerMode = 'preview' | 'design'
export type PropertyPanelType = 'general' | 'properties' | 'fields' | 'templates';
export type LeftPanelType = 'sections' | 'fields' | 'widgets'

export interface IDesignerInstanceProps {
    save: (key?: string) => Promise<any>,
    saveAsTemplate: () => Promise<any>,
    delete: () => Promise<any>,
    export: () => void,
    getDefinition: () => Promise<any>,
}

export interface IErrorProps {
    id: string,
    error: string,
    type: 'property' | 'general',
    containerId?: string,
    fieldId?: string,
    fieldClassName?: string,
    highLightOnAdd?: boolean
}

interface IAppBarButton {
    id: string,
    icon: string,
    label: string,
    onClick: IAction
}

interface IMobileLayout {
    tabs: IMobileNavigationTab[],
    selectedTab: IMobileNavigationTab,
    selectedTabProps: any
}
const Designer: React.ForwardRefExoticComponent<React.RefAttributes<IDesignerInstanceProps> & IDesignerProps> = React.forwardRef((props, ref) => {

    let { isNew, template, widget, uxpContext, enableSave, onModifiyContent, templateId, mobileConfigurations } = props
    const isMobile = props.isMobile || false

    const toast = useToast()
    const alerts = useAlert()
    const history = useHistory()
    // const location = useLocation()
    const Width = 1200;

    let [undoManager] = React.useState<UndoManager<any>>(new UndoManager())

    const [mode, setMode] = React.useState<IDesignerMode>('design')
    const [selectedRightPanel, setSelectedRightPanel] = React.useState<PropertyPanelType>('general');
    const [selectedLeftPanel, setSelectedLeftPanel] = React.useState<LeftPanelType>(isMobile ? 'sections' : 'fields')

    let [name, setName] = React.useState("")
    let [description, setDescription] = React.useState("")
    let [icon, setIcon] = React.useState("solidImage")
    let [notificationTitle, setNotificationTitle] = React.useState("")
    let [notificationBody, setNotificationBody] = React.useState("")
    let [uiBG, setUIBG] = React.useState('');
    let [anonymous, setAnonymous] = React.useState(0);
    let [uiProps, setUiProps] = React.useState<any>({});

    let [selected, setSelected] = React.useState<any>();
    let [selectedProps, setSelectedProps] = React.useState<ISelectableItemUIProp[]>([]);
    let [customDataOfSelectedPart, setCustomDataOfSelectedPart] = React.useState({})
    const [containerId, setContainerId] = React.useState<string>(null)

    let [width, setWidth] = React.useState(document.body.clientWidth > Width ? document.body.clientWidth : Width)
    let [zoom, setZoom] = React.useState(1)
    let [locked, setLocked] = React.useState(true)
    let [widgetLayout, setWidgetLayout] = React.useState<any>({ x: 5, y: 0, w: 10, h: 10, i: generateUUID() })

    const [allUserTemplates, setAllUserTempaltes] = React.useState([])
    const [templateName, setTemplateName] = React.useState('')
    const [templateDescription, setTemplateDescription] = React.useState('')

    const [errors, setErrors] = React.useState<{ [id: string]: IErrorProps }>({})

    // for mobile app 
    const [view, setView] = React.useState<'home' | 'login'>('home')

    const [loginLogo, setLoginLogo] = React.useState('')
    const [backgroundImage, setBackgroundImage] = React.useState('')
    const [logo, setLogo] = React.useState('')
    const [backgroundColor, setBackgroundColor] = React.useState('white')
    const [bottomNavigationBarBackgroundColor, setBottomNavigationBarBackgroundColor] = React.useState('')
    const [bottomNavagationBarSelectedItemColor, setBottomNavagationBarSelectedItemColor] = React.useState('grey')
    const [bottomNavigationBarUnselectedItemColor, setBottomNavigationBarUnselectedItemColor] = React.useState('lightgrey')
    const [appBarHeight, setAppBarHeight] = React.useState('7')
    const [appBarBackgroundColor, setAppBarBackgroundColor] = React.useState('lightgrey')
    const [appBarBackgroundImage, setAppBarBackgroundImage] = React.useState('')
    const [appBarText, setAppBarText] = React.useState('Explore Lucy Mobile')
    const [textColor, setTextColor] = React.useState('#424242')
    const [appBarButtons, setAppBarButtons] = React.useState<IAppBarButton[]>([])
    const [previewAppHeader, setPreviewAppHeader] = React.useState(false)

    const [mobileLayout, setMobileLayout] = React.useState<IMobileLayout>({
        tabs: [],
        selectedTab: null,
        selectedTabProps: {}
    })

    const hasModifiedRef = React.useRef(false)
    const templateRef: React.MutableRefObject<IWidgetTemplateInstanceProps> = React.useRef(null)
    const errorsRef = React.useRef<{ [id: string]: IErrorProps }>({})

    const removeError = (id: string) => {
        let _errs = { ...errorsRef.current }
        const err = _errs[id]
        if (hasValue(err?.fieldId)) {
            const fieldId = bindContainerId(err.fieldId, err.type === 'property' ? err.containerId : null)
            const field = document.getElementById(fieldId)

            if (field) field.classList.remove('has-error')
        }

        if (hasValue(err?.fieldClassName)) {
            const className = bindContainerId(err.fieldClassName, err.type === 'property' ? err.containerId : null)
            const fields = document.getElementsByClassName(className) as any

            [...fields]?.forEach((field: any) => {
                if (field) field.classList.remove('has-error')
            })
        }

        delete _errs?.[id]

        errorsRef.current = _errs
        setErrors(_errs)
    }

    const designer: IWDDesignModeProps = {
        mode: 'preview',
        widgetName: name,
        onSelect: (ref: any, props: any, data: any, id?: string) => {
            setSelected(ref);
            setSelectedProps(props);
            setCustomDataOfSelectedPart(data)
            setContainerId(id)

            if (selectedRightPanel !== 'properties') setSelectedRightPanel('properties')
        },
        selectedItem: selected,
        selectedPanel: selectedRightPanel,
        setUIProps: (p: any) => {
            setUiProps(p);
            /* if the user overrides the onChange in SelectableItem, call that one, else call the default one */
        },
        setWidgetProperties: (p: IWidgetProps) => {
            if (p.description != undefined) {
                setDescription(p.description);
            }
            if (p.name != undefined) {
                setName(p.name);
            }
            if (p.height != undefined) {
                let layout = widgetLayout;
                layout.h = p.height;
                setWidgetLayout(Object.assign({}, layout));
            }
        },
        setMobileCardUIProps: (id, updatedProps, field) => {
            const prev = { ...uiProps }

            const fields: any = (field == 'fields') ? (prev['fields'] || []) : (prev?.['filter']?.['fields'] || [])
            if (fields && fields.length > 0) {
                for (const f of fields) {
                    if (f.id === id) {
                        f.props = { uiProps: updatedProps }
                    }
                }

                if (field == 'fields') prev['fields'] = fields
                else {
                    if (!prev['filter']) prev.filter = { fillContainer: false, enableClear: true, fields: [] }
                    prev['filter']['fields'] = fields
                }
            }

            setUiProps(prev)

            const _mobileLayout = { ...mobileLayout }
            _mobileLayout.selectedTabProps = prev
            const updatedTabs = _mobileLayout?.tabs?.map(t => {
                if (t.id == _mobileLayout?.selectedTab?.id) {
                    t.props = prev
                }
                return t
            })

            setMobileLayout(_mobileLayout)
        },
        sourceBrowser: props.sourceBrowser,
        addErrors: (errors: IErrorProps[]) => {
            let _errs = { ...errorsRef.current }
            for (const e of errors) {
                _errs[e.id] = e
            }
            errorsRef.current = _errs
            setErrors(_errs)
        },
        removeAllErrors: () => {
            let _errs = { ...errorsRef.current }
            for (let id in _errs) {
                removeError(id)
            }
        },
        removeErrors: (ids: string[]) => {
            console.log("removing errors", ids)

            for (const id of ids) {
                removeError(id)
            }

            console.log("errors", errorsRef.current)
        },
        isMobile: isMobile
    };

    React.useEffect(() => {
        console.log('zoom-changed', zoom);
    }, [zoom])
    React.useImperativeHandle(ref, () => ({
        save: saveWidget,
        saveAsTemplate: saveAsTemplate,
        delete: deleteWidget,
        export: exportWidget,
        getDefinition: getWidgetDefinition,
    }))

    React.useEffect(() => {
        window.onbeforeunload = (e: any) => {
            if (hasModifiedRef.current) {
                return 'You have pending changes. If you leave this screen you will lose those changes. Continue anyway?';
            }
            return null;
        };
    }, [])

    React.useEffect(() => {
        designer.removeAllErrors()
        getAllUserTemplates()
    }, [])

    React.useEffect(() => {
        setLoginLogo(mobileConfigurations?.loginLogo)
        setBackgroundImage(mobileConfigurations?.backgroundImage)
        setLogo(mobileConfigurations?.logo)
        setBackgroundColor(mobileConfigurations?.backgroundColor)
        setBottomNavigationBarBackgroundColor(mobileConfigurations?.bottomNavigationBarBackgroundColor)
        setBottomNavagationBarSelectedItemColor(mobileConfigurations?.bottomNavagationBarSelectedItemColor)
        setBottomNavigationBarUnselectedItemColor(mobileConfigurations?.bottomNavigationBarUnselectedItemColor)
        setAppBarHeight(mobileConfigurations?.appBarHeight)
        setAppBarBackgroundColor(mobileConfigurations?.appBarBackgroundColor)
        setAppBarBackgroundImage(mobileConfigurations?.appBarBackgroundImage)
        setAppBarText(mobileConfigurations?.appBarText)
        setTextColor(mobileConfigurations?.textColor)
        setAppBarButtons(mobileConfigurations?.appBarButtons)

    }, [mobileConfigurations])

    useEffect(() => {
        setUiProps((prev: any) => ({ ...prev, __widget_name__: name }))
    }, [name])

    React.useEffect(() => {
        if (hasValue(templateId)) {
            const key = getUserTemplateKeyFromId(templateId)

            if (!!key) {
                uxpContext.executeService('UXP', 'UserWidgetTemplate:Details', { Key: key }, { json: true })
                    .then(res => {
                        // getting details form user template and updating the states 
                        const { Key, Name, Description, Template, Icon, BackgroundImage, NotificationBody, NotificationTitle, Anonymous } = res[0]
                        let _template = tryParseJSON(Template)
                        if (_template) {
                            setUiProps(_template.uiProps)
                        }
                        setUIBG(BackgroundImage)
                        setNotificationTitle(NotificationTitle)
                        setNotificationBody(NotificationBody)
                        setAnonymous(Anonymous)
                        setIcon(Icon)
                    })
                    .catch(e => {
                        console.log('unable to get the template details ', e);
                    })
            }
        }
    }, [templateId])

    React.useEffect(() => {
        console.log('widget he layout', widgetLayout);

    }, [widgetLayout])

    React.useEffect(() => {
        if (widget) {
            let _uiProps = widget.Template.uiProps || {}
            let _template = widget.Template.__template__

            setUiProps(_uiProps)
            setName(widget.Name)
            setDescription(widget.Description)
            setIcon(widget.Icon)
            setNotificationTitle(widget.NotificationTitle)
            setNotificationBody(widget.NotificationBody)
            setUIBG(widget.BackgroundImage)
            setAnonymous(Number(widget.Anonymous))

            if (_template) {
                let _layout = _template.layout
                _layout = { w: 10, h: 10, ..._layout }
                setWidgetLayout({ x: 5, y: 0, w: _layout.w, h: _layout.h, i: generateUUID(), static: false })

                if (_template.zoom) {
                    setZoom(_template.zoom || 0)
                }
                if (_template.locked) {
                    setLocked(_template.locked || false)
                }
            }

        }
        else if (template) {
            let _layout = template.layout
            _layout = { w: 10, h: 10, ..._layout }
            setWidgetLayout({ x: 5, y: 0, w: _layout.w, h: _layout.h, i: generateUUID(), static: false })
        }

    }, [widget, template])


    React.useEffect(() => {
        const searchProps = new URLSearchParams(window.location.search)
        let _mode: IDesignerMode = 'design'
        if (searchProps.get('preview') == '1') _mode = 'preview'

        if (props.mode !== _mode) props.onChangeMode(_mode)
    }, [window.location])

    React.useEffect(() => {
        setMode(props.mode)
    }, [props.mode])

    React.useEffect(() => {


        const _uiProps = { ...props?.uiProps || { 'tabs': [] } }
        if (_uiProps || isMobile) {
            if (isMobile) {

                if (!_uiProps?.tabs) _uiProps.tabs = []

                const { homeTab, settingsTab, searchTab, otherTabs } = extractTabs(_uiProps.tabs)
                _uiProps.tabs = [homeTab, ...otherTabs, settingsTab, searchTab]

                const _mobileLayout = { ...mobileLayout }
                _mobileLayout.tabs = _uiProps.tabs

                const selectedTab = _mobileLayout.tabs.find(t => _mobileLayout?.selectedTab?.id == t.id)

                if (selectedTab) _mobileLayout.selectedTab = selectedTab
                else _mobileLayout.selectedTab = _mobileLayout.tabs[0]

                _mobileLayout.selectedTabProps = _mobileLayout?.selectedTab?.props || {}

                setMobileLayout(_mobileLayout)
                setUiProps(_mobileLayout.selectedTabProps)
                return
            }
            setUiProps(_uiProps)
        }
    }, [props.uiProps])



    React.useEffect(() => {
        console.log('UPDATED_UIPROPS', uiProps, mobileLayout);

    }, [uiProps, mobileLayout])

    React.useEffect(() => {
        if (mode === 'preview') {
            if (templateRef.current?.onPreview) {
                const canPreview = templateRef.current.onPreview()
                if (!canPreview) props.onChangeMode('design')
            }
        }
    }, [mode])

    React.useEffect(() => {
        undoManager?.addState({
            name,
            description,
            icon,
            notificationBody,
            notificationTitle,
            uiBG,
            anonymous,
            zoom,
            widgetLayout: _.cloneDeep(widgetLayout),
            locked,
            uiProps: _.cloneDeep(uiProps)
        })

        const hasUpdated = undoManager.canUndo()
        enableSave(hasUpdated && canSave())
        onModifiyContent(hasUpdated)
        hasModifiedRef.current = hasUpdated

    }, [name, description, icon, notificationTitle, notificationBody, uiBG, anonymous, zoom, widgetLayout, locked, uiProps])


    function getAllUserTemplates() {
        uxpContext.executeService('UXP', 'UserWidgetTemplate:AllTemplates', {}, { json: true })
            .then(res => {
                console.log('response ', res);

                setAllUserTempaltes(res)
            })
            .catch(e => {
                console.log('Unable to get all user templates',);

            })
    }

    function onDragEnd(result: DropResult) {
        console.log('drop-result_____ondrop', result)
        if (result.destination) {
            let obj = getTag(result.draggableId);

            triggerDrop(result.destination.droppableId, {
                data: obj,
                index: result.destination.index,
                source: result.source.droppableId,
                destination: result.destination.droppableId
            });
        }
    }

    function onUndoRedo(state?: any) {
        if (state) {
            setName(state.name)
            setDescription(state.description)
            setIcon(state.icon)
            setNotificationBody(state.notificationBody)
            setNotificationTitle(state.notificationTitle)
            setUIBG(state.uiBG)
            setAnonymous(Number(state.anonymous) || 0)
            setZoom(state.zoom)
            setWidgetLayout(state.widgetLayout)
            setLocked(state.locked)
            setUiProps(state.uiProps)
        }
    }

    function clearSelection() {
        setSelected(null);
        setContainerId(null);
    }

    function renderLeftPanels() {
        if (selectedLeftPanel == 'fields') return <FieldPanel />
        else if (selectedLeftPanel == 'sections') return <MobileFieldsPanel />
        else if (selectedLeftPanel == 'widgets') return <WidgetPanel uxpContext={uxpContext} />
        return null
    }

    function renderRightPanels() {
        if (selectedRightPanel == 'general') {
            return <div className='general-tab' >
                {isMobile ? <>
                    <PropertyContainer>
                        <PropertyContainerTitle>General</PropertyContainerTitle>

                        <div style={{ textAlign: 'center' }}>
                            <small>
                                <i>These settings will be common for all user groups</i>
                            </small>
                        </div>

                        <div className='mobile-config-toggle-button-container'>

                            <ToggleFilter
                                value={view}
                                onChange={(s: any) => setView(s)}
                                options={[
                                    { label: 'Home Page', value: 'home' },
                                    { label: 'Login Page', value: 'login' }
                                ]}
                                className=''
                            />
                        </div>

                        {view === 'home'
                            ?
                            <>
                                <PropertyGroup>

                                    {/* <Property>
                                        <Checkbox
                                            checked={previewAppHeader}
                                            onChange={setPreviewAppHeader}
                                            label='Preview app header'
                                            type='bordered'
                                        />
                                    </Property> */}

                                    <Property id='mobile-app-bar-height'>
                                        <Label>App bar height</Label>
                                        <Input
                                            type='number'
                                            value={appBarHeight}
                                            onChange={s => {
                                                const num = Number(s)
                                                if (num < 7) s = '7'
                                                else if (num > 100) s = '100'
                                                setAppBarHeight(s)
                                            }}
                                            inputAttr={{
                                                max: '100',
                                                min: '7'
                                            }}
                                        />
                                    </Property>

                                    <Property id='mobile-app-bar-background-color'>
                                        <Label>App bar background color</Label>
                                        <CustomColorPicker contextData={customDataOfSelectedPart}
                                            color={appBarBackgroundColor || ''}
                                            onChange={setAppBarBackgroundColor}
                                        />
                                    </Property>

                                    <Property id='mobile-app-bar-background-image'>
                                        <Label>App bar background image</Label>
                                        <ImagePicker
                                            uxpContext={uxpContext}
                                            imageUrl={appBarBackgroundImage}
                                            onChange={setAppBarBackgroundImage}
                                        />
                                    </Property>

                                    <Property id='mobile-logo'>
                                        <Label>App bar Logo</Label>
                                        <ImagePicker
                                            imageUrl={logo}
                                            onChange={setLogo}
                                            uxpContext={uxpContext}
                                        />
                                    </Property>

                                    <Property id='mobile-app-bar-title'>
                                        <Label>App bar title </Label>
                                        <Input
                                            value={appBarText}
                                            onChange={setAppBarText}
                                        />
                                    </Property>

                                    <Property id='mobile-app-bar-title'>
                                        <Label>App bar title color </Label>
                                        <Input
                                            value={textColor}
                                            onChange={setTextColor}
                                        />
                                    </Property>

                                    <Property id='mobile-background'>
                                        <Label>Content Background Color</Label>
                                        <CustomColorPicker contextData={customDataOfSelectedPart}
                                            color={backgroundColor || ''}
                                            onChange={setBackgroundColor}
                                        />
                                    </Property>


                                </PropertyGroup>

                                <PropertyGroup>
                                    <PropertyGroupTitle>Header Icon Buttons</PropertyGroupTitle>

                                    <div className="wd-mobile-navigation-tabs-config-container">
                                        <SortableList
                                            items={appBarButtons}
                                            onSort={setAppBarButtons}
                                            renderItem={(b, i) => {

                                                return <div className="wd-mobile-navigation-tabs-config-tab">

                                                    <div className="wd-mobile-navigation-tabs-config-tab-remover"
                                                        onClick={() => {
                                                            const updated = appBarButtons.filter(item => item.id !== b.id)
                                                            setAppBarButtons(updated)
                                                        }}
                                                    >
                                                        <FontAwesomeIcon icon={['fas', 'times']} />
                                                    </div>


                                                    <div className="wd-mobile-navigation-tabs-config-label">{b.label}</div>

                                                    <div className="wd-mobile-navigation-tabs-config-content">
                                                        <div className="section">
                                                            <Label>Name</Label>
                                                            <Input
                                                                value={b.label}
                                                                onChange={v => {
                                                                    const updated = appBarButtons.map(item => {
                                                                        if (item.id === b.id) {
                                                                            b.label = v
                                                                        }
                                                                        return item
                                                                    })
                                                                    setAppBarButtons(updated)
                                                                }}
                                                                className="widget-designer-input"
                                                            />
                                                        </div>

                                                        <div className="section">
                                                            <Label>Icon</Label>
                                                            <IconEditor
                                                                value={b.icon}
                                                                onChange={v => {
                                                                    const updated = appBarButtons.map(item => {
                                                                        if (item.id === b.id) {
                                                                            b.icon = v
                                                                        }
                                                                        return item
                                                                    })
                                                                    setAppBarButtons(updated)
                                                                }}
                                                            />
                                                        </div>

                                                        <div className="section">
                                                            <Label>On Click</Label>
                                                            <ActionEditorLink
                                                                action={b.onClick}
                                                                onChange={v => {
                                                                    const updated = appBarButtons.map(item => {
                                                                        if (item.id === b.id) {
                                                                            b.onClick = v
                                                                        }
                                                                        return item
                                                                    })
                                                                    setAppBarButtons(updated)
                                                                }}
                                                                uxpContext={props.uxpContext}
                                                                uiProps={props.uiProps}
                                                                settings={{
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            }}
                                        />
                                        <div className="wd-mobile-navigation-tabs-config-tab">
                                            <Button
                                                className="new-option"
                                                title="Add Button"
                                                icon={"/Resources/Lucy/lucy-dashboard/assets/images/plus-rounded.svg"}
                                                iconPosition="right"
                                                onClick={() => {
                                                    const _buttons = [...appBarButtons]
                                                    _buttons.push({
                                                        id: generateUUID(),
                                                        icon: getRandomIcon(),
                                                        label: `Button ${_buttons.length + 1}`,
                                                        onClick: { type: 'open-url' }
                                                    })
                                                    setAppBarButtons(_buttons)
                                                }}
                                                active={true}
                                            />
                                        </div>
                                    </div>

                                </PropertyGroup>

                                <PropertyGroup>

                                    <Property id='mobile-navigation-background'>
                                        <Label>Navigation Bar Background Color</Label>
                                        <CustomColorPicker contextData={customDataOfSelectedPart}
                                            color={bottomNavigationBarBackgroundColor || ''}
                                            onChange={setBottomNavigationBarBackgroundColor}
                                        />
                                    </Property>

                                    <Property id='mobile-navigation-button'>
                                        <Label>Navigation Bar Button Color</Label>
                                        <CustomColorPicker contextData={customDataOfSelectedPart}
                                            color={bottomNavigationBarUnselectedItemColor || ''}
                                            onChange={setBottomNavigationBarUnselectedItemColor}
                                        />
                                    </Property>

                                    <Property id='mobile-navigation-button-active'>
                                        <Label>Navigation Bar Active Button Color</Label>
                                        <CustomColorPicker contextData={customDataOfSelectedPart}
                                            color={bottomNavagationBarSelectedItemColor || ''}
                                            onChange={setBottomNavagationBarSelectedItemColor}
                                        />
                                    </Property>

                                </PropertyGroup>
                            </>
                            :
                            <PropertyGroup>
                                <Property id='mobile-login-logo'>
                                    <Label>Logo</Label>
                                    <ImagePicker
                                        imageUrl={loginLogo}
                                        onChange={setLoginLogo}
                                        uxpContext={uxpContext}
                                    />
                                </Property>

                                <Property id='mobile-login-bg'>
                                    <Label>Background Image</Label>
                                    <ImagePicker
                                        imageUrl={backgroundImage}
                                        onChange={setBackgroundImage}
                                        uxpContext={uxpContext}
                                    />
                                </Property>
                            </PropertyGroup>
                        }
                    </PropertyContainer>
                </>
                    : <>
                        {/* general  */}
                        <PropertyContainer>
                            <PropertyContainerTitle>General</PropertyContainerTitle>
                            <PropertyGroup>
                                <Property id='general-name'>
                                    <Label>Name</Label>
                                    <Input
                                        value={name}
                                        onChange={s => {
                                            setName(s)
                                            if (hasValue(s)) designer.removeErrors(['general-name'])
                                        }}
                                        placeholder=""
                                        className="widget-designer-input"
                                    />
                                </Property>
                                <Property id='general-description'>
                                    <Label>Description</Label>
                                    <Input
                                        value={description}
                                        onChange={setDescription}
                                        placeholder=""
                                        className="widget-designer-input"
                                    />
                                </Property>
                                <Property id='general-icon'>
                                    <Label>Icon</Label>
                                    <IconEditor
                                        value={icon}
                                        onChange={setIcon}
                                    />
                                </Property>
                            </PropertyGroup>

                        </PropertyContainer>

                        {/* datasources */}
                        <PropertyContainer>
                            <PropertyContainerTitle>Data sources </PropertyContainerTitle>
                            <PropertyGroup>
                                <Property>

                                    <MultipleDataSourceEditor
                                        uxpContext={uxpContext}
                                        designer={designer}
                                        sources={uiProps?.datasources || []}
                                        bindings={uiProps?.initialSources || []}
                                        onChange={(key, val) => {
                                            console.log('sources__updating_uiProps', key, val)

                                            if (key == 'sources') injectAtPath(uiProps, 'datasources', val)
                                            else if (key == 'binding') injectAtPath(uiProps, 'initialSources', val)
                                            setUiProps({ ...uiProps })
                                            // setUiProps((prev: any) => {

                                            //     if(key == 'sources') prev.datasources = val 
                                            //     else prev.initialSources = val

                                            //     console.log("sources____beforeset ", prev)
                                            //     return prev
                                            // })
                                        }}
                                    />

                                </Property>
                            </PropertyGroup>
                        </PropertyContainer>

                        {/* params */}
                        <PropertyContainer>
                            <PropertyContainerTitle>Params</PropertyContainerTitle>
                            <PropertyContainerSubTitle>These will be passed when the widget is rendering</PropertyContainerSubTitle>

                            <PropertyGroup>
                                <WidgetParamsEditor
                                    uxpContext={uxpContext}
                                    designer={designer}
                                    params={uiProps?.params || []}
                                    onChange={(newParams) => {
                                        const _uiProps = Object.assign({}, uiProps, { params: newParams })
                                        setUiProps(_uiProps)
                                    }}
                                />
                            </PropertyGroup>

                        </PropertyContainer>

                        {/* share */}
                        <PropertyContainer>
                            <PropertyContainerTitle>Share</PropertyContainerTitle>
                            <PropertyGroup>
                                <Property>
                                    <Label>Page Background Image</Label>
                                    <ImagePicker
                                        uxpContext={uxpContext}
                                        imageUrl={uiBG}
                                        onChange={setUIBG}
                                    />

                                </Property>

                                <Property>
                                    <Label>Shareable Url</Label>
                                    <div className='share-url'>
                                        <Input
                                            value={!!name ? (LocationOrigin + '/Apps/UXP/page/' + name) : 'Save your changes to share'}
                                            onChange={() => { }}
                                            placeholder=""
                                            className="widget-designer-input"
                                        />
                                        {!!name && <div className='share-icon'>
                                            <FontAwesomeIcon size='2x' icon={'arrow-square-up'} onClick={() => window.open(LocationOrigin + '/Apps/UXP/page/' + name)} />
                                        </div>}
                                    </div>

                                </Property>
                                <Property>
                                    <Label>Allow anonymous access (login not required)</Label>
                                    <Checkbox
                                        checked={anonymous == 1}
                                        onChange={(c) => setAnonymous(c ? 1 : 0)}
                                        label='Anonymous access allowed'
                                        className="widget-designer-input"
                                    />
                                </Property>
                            </PropertyGroup>
                        </PropertyContainer>

                        {/* mobile */}
                        <PropertyContainer>
                            <PropertyContainerTitle>Mobile</PropertyContainerTitle>
                            <PropertyGroup>
                                <Property>
                                    <Label>Notification Title</Label>
                                    <Input
                                        value={notificationTitle}
                                        onChange={setNotificationTitle}
                                        placeholder=""
                                        className="widget-designer-input"
                                    />
                                </Property>
                                <Property>
                                    <Label>Notification Body</Label>
                                    <Input
                                        value={notificationBody}
                                        onChange={setNotificationBody}
                                        placeholder=""
                                        className="widget-designer-input"
                                    />
                                </Property>
                            </PropertyGroup>
                        </PropertyContainer>
                    </>
                }

            </div>
        }

        if (selectedRightPanel == 'properties') {
            if (selected) {
                return <PropertyPanel
                    uiProps={uiProps}
                    props={selectedProps}
                    uxpContext={uxpContext}
                    designer={designer}
                    contextData={customDataOfSelectedPart}
                    onChange={(id, value) => {
                        let onChange = selected?.current?.onChange;
                        if (onChange) {
                            onChange(value);
                        } else {
                            injectAtPath(uiProps, id, value);
                            setUiProps({ ...uiProps });
                        }
                    }}
                    selectedContainer={containerId}
                    elementId={selected?.current?.elementId}
                    isMobile={isMobile}
                />;
            }
            else {
                return <div className="not-selected">Select a highlighted area to configure the properties</div>;
            }
        }
    }

    function canSave() {
        if (isMobile) return true
        return (hasValue(name) && hasValue(description))
    }

    function isValid() {
        if (isMobile) return true
        if (!hasValue(name)) {
            designer.addErrors([{
                id: 'general-name',
                type: 'general',
                error: 'Name is required',
                fieldId: 'general-name'
            }])
            return false
        }
        designer.removeErrors(['general-name'])
        return true
    }
    async function getWidgetDefinition() {
        return new Promise<any>(async (done, nope) => {
            let _uiProps = { ...uiProps }

            if (isMobile) {
                done({
                    uiProps: { tabs: mobileLayout?.tabs || [] },
                    loginLogo: loginLogo,
                    backgroundImage: backgroundImage,
                    logo: logo,
                    backgroundColor: backgroundColor,
                    bottomNavigationBarBackgroundColor: bottomNavigationBarBackgroundColor,
                    bottomNavigationBarUnselectedItemColor: bottomNavigationBarUnselectedItemColor,
                    bottomNavagationBarSelectedItemColor: bottomNavagationBarSelectedItemColor,
                    hideLucyLogo: hasValue(logo),
                    appBarHeight: appBarHeight,
                    appBarBackgroundColor: appBarBackgroundColor,
                    appBarBackgroundImage: appBarBackgroundImage,
                    appBarText: appBarText,
                    appBarButtons: appBarButtons
                });
            }
            else {
                // validate template 
                if (templateRef.current?.beforeSave) {
                    let validationResponse = templateRef.current.beforeSave(isNew, widget?.Key, null)
                    let canSave = false
                    if (isPromise(validationResponse)) {
                        let res = await validationResponse
                        if (typeof res === 'boolean') canSave = res
                        else {
                            canSave = res.canSave
                            _uiProps = { ...res.updatedProps }
                        }
                    }
                    else {
                        canSave = validationResponse as boolean
                    }

                    if (!canSave) return nope('Prevented saving form template')
                }

                //validate general details
                if (!isValid()) return nope('Not completed')


                let instanceId = generateFullUUID()
                if (!isNew && widget) {
                    instanceId = widget.ID
                }
                let _template: any = {
                    __template__: {
                        type: template.id,
                        id: instanceId,
                        layout: { w: widgetLayout.w, h: widgetLayout.h },
                        zoom: zoom,
                        locked: locked
                    },
                    uiProps: _uiProps
                }
                done({ name, description, definition: _template, icon });
            }
        })
    }
    async function saveWidget(modelKey?: string) {

        return new Promise<any>(async (done, nope) => {
            let modelReference = modelKey || props.modelKey;
            let _uiProps = { ...uiProps }

            // validate template 
            if (templateRef.current?.beforeSave) {
                let validationResponse = templateRef.current.beforeSave(isNew, widget?.Key, modelKey)
                let canSave = false
                if (isPromise(validationResponse)) {
                    let res = await validationResponse
                    if (typeof res === 'boolean') canSave = res
                    else {
                        canSave = res.canSave
                        _uiProps = { ...res.updatedProps }
                    }
                }
                else {
                    canSave = validationResponse as boolean
                }

                if (!canSave) return nope('Prevented saving form template')
            }

            //validate general details
            if (!isValid()) return nope('Not completed')

            let app = 'UXP'
            let model = 'CardTemplate'
            let service = isNew ? 'Create' : 'Update'

            let instanceId = generateFullUUID()
            let moduleId = extractModuleIdFromURL()
            if (!hasValue(moduleId)) moduleId = BundleConfig.id
            let widgetId = `${moduleId}/widget/${template.id}`


            if (!isNew && widget) {
                instanceId = widget.ID
                widgetId = widget.WidgetID
            }
            let _template: any = {
                __template__: {
                    type: template.id,
                    id: instanceId,
                    layout: { w: widgetLayout.w, h: widgetLayout.h },
                    zoom: zoom,
                    locked: locked
                },
                uiProps: _uiProps
            }
            let params: any = {
                ID: instanceId,
                WidgetID: widgetId,
                Name: name,
                Description: description,
                Icon: icon,
                Template: JSON.stringify(_template),

                MapKey: Number(modelReference) ? modelReference : undefined,

                NotificationTitle: notificationTitle || '',
                NotificationBody: notificationBody || '',
                BackgroundImage: uiBG || '',
                Anonymous: anonymous,
                IsCustomTemplate: template.isDefaultTemplate ? '0' : '1'
            }

            if (!isNew) {
                params.Key = widget?.Key
            }

            uxpContext.executeService(app, `${model}:${service}`, params, { json: true })
                .then(res => {
                    toast.success('Saved!')

                    let key = widget?.Key
                    if (isNew) key = res[0].Key
                    hasModifiedRef.current = false
                    if (key && history?.push) {
                        history.push(buildUrl(uxpContext, ['widgets', 'edit', key]))
                    }
                    done(key)
                })
                .catch(e => {
                    console.error(e);
                    nope(e)
                    if (e == 'An item with the given Name already exists') {
                        alerts.show({
                            title: 'Name is not available',
                            content: 'Please give a differnet name. A widget exists with the given name'
                        })
                    }
                    else {
                        alerts.show({
                            title: 'Error occured!',
                            content: 'Something went wrong'
                        })
                    }
                })

        })
    }

    async function captureTemplateDetails() {
        const formData = await alerts.form({
            title: 'Template Details',
            formStructure: [
                {
                    name: 'name',
                    label: 'Template Name',
                    type: 'string',
                    validate: {
                        required: true,
                        minLength: 1
                    }
                },
                {
                    name: 'description',
                    label: 'Template Description',
                    type: 'string',
                    validate: {
                        required: false
                    }
                }
            ]
        })
        console.log('formdata ', formData);

        return formData
    }

    async function getTemplateDetails() {
        let name: string = templateName
        let description: string = templateDescription
        let overrideExisting: boolean = false
        let key: string = null

        if (!hasValue(name)) {
            const formData = await captureTemplateDetails()
            name = formData.name
            description = formData.description
        }

        console.log('details ', name, description);

        const inst = allUserTemplates.find(ut => ut.Name == name)
        console.log('existing ', inst);

        if (inst) {
            const tOverride = await alerts.confirm('Template with given name already exists. Do you want to override it?')
            if (tOverride) {
                overrideExisting = true
                key = inst.Key
            }
            else return null
        }

        return { name, description, overrideExisting, key }
    }


    async function saveAsTemplate() {
        return new Promise<any>(async (done, nope) => {
            let _uiProps = { ...uiProps }

            // validate template 
            if (templateRef.current?.beforeSave) {
                let validationResponse = templateRef.current.beforeSave(isNew)
                let canSave = false
                if (isPromise(validationResponse)) {
                    let res = await validationResponse
                    if (typeof res === 'boolean') canSave = res
                    else {
                        canSave = res.canSave
                        _uiProps = { ...res.updatedProps }
                    }
                }
                else {
                    canSave = validationResponse as boolean
                }

                if (!canSave) return nope('Prevented saving form template')
            }

            // validate name 
            const details = await getTemplateDetails()
            console.log('details ', details);

            if (!details) {
                nope('prevented from overriding existing template')
                return
            }

            let app = 'UXP'
            let model = 'UserWidgetTemplate'
            let service = details.overrideExisting ? 'Update' : 'Create'

            const _template: any = {
                __template__: {
                    type: template.id,
                    layout: { w: widgetLayout.w, h: widgetLayout.h },
                    zoom: zoom,
                    locked: locked
                },
                uiProps: _uiProps
            }


            let moduleId = extractModuleIdFromURL()
            if (!hasValue(moduleId)) moduleId = BundleConfig.id
            let widgetId = `${moduleId}/widget/${template.id}`

            const params: any = {
                WidgetID: widgetId,
                Name: details.name,
                Description: details.description,
                Template: JSON.stringify(_template),
                Icon: icon,
                NotificationTitle: notificationTitle || '',
                NotificationBody: notificationBody || '',
                BackgroundImage: uiBG || '',
                Anonymous: anonymous
            }

            if (details.overrideExisting) {
                params.Key = details.key
            }

            uxpContext.executeService(app, `${model}:${service}`, params, { json: true })
                .then(res => {
                    toast.success('Widget saved as a template.')
                    done('saved')

                    eventDispatcher('uxp-designer-save-as-tempalte', 'save-as-template')
                })
                .catch(e => {
                    console.log('error ', e);
                    toast.error('Unable to save the widget as a template')
                    nope(e)
                })
                .finally(() => {
                    getAllUserTemplates()
                })
        })
    }

    async function deleteWidget() {
        try {
            // confirm
            alerts.confirm({
                title: 'Delete Widget',
                content: 'This action cannot be undone. Do you wish to continue?',
                confirmButtonTitle: "Yes",
                cancelButtonTitle: 'No'
            })
                .then((res: any) => {
                    if (res) {
                        props.uxpContext?.executeService('UXP', 'CardTemplate:Delete', { 'key': widget?.Key })
                            .then(res => {
                                console.log('response ', res)
                                history.push(buildUrl(props.uxpContext, ''))
                            })
                            .catch(e => {
                                console.log(e);
                            })
                    }
                })

        }
        catch (e) {

        }
    }

    function exportWidget() {

        if (hasModifiedRef.current) {
            alerts.show('You have some unsaved changes. Save them before continue')
            return
        }

        const url = `/Services/UXP/DownloadCard?__sc__=${uxpContext.apiKey}&Name=${name}`
        window.open(url)
    }

    const hasLeftPanel = (mode === 'design' && (template?.canDragDropFields || isMobile))
    const hasRightpanel = mode === 'design'

    let _width = width
    let numClos = 30

    let _zoom = mode == 'preview' ? 0 : zoom
    if (_zoom > 1 && !isMobile) {
        _width = _width + _width * _zoom
    }

    let margin: [number, number] = [10, 10]
    let rowHeight = (_width - (margin[0] * (numClos + 1))) / numClos;

    let styles: any = {
        width: _width,
        height: _width,
        '--cellInnerWidth': rowHeight - 0.5 + 'px',
        '--cellWidth': rowHeight + 'px'
    }
    if (isMobile) styles = { width: '100%', height: '100%', minWidth: '300px', minHeight: '500px' }

    function updateWidgetHeight(height: number) {
        console.log('widget height in px', height, _width, _width / numClos, rowHeight)

        let _layout = Object.assign({}, JSON.parse(JSON.stringify(widgetLayout)))
        let h = Math.ceil(height / rowHeight)
        // Math.ceil((height - margin[1]) / (rowHeight + margin[1]));

        _layout.h = h

        setWidgetLayout(_layout)
    }

    return <DragDropContext onDragEnd={onDragEnd}>

        <div className={classNames("wd-container", { 'has-left-sidebar': hasLeftPanel, 'has-right-sidebar': hasRightpanel })}
        >
            {hasLeftPanel &&
                <div className='wd-panels-container left'>
                    <div className="wd-panels">
                        <div className='wd-panel-actions'>
                        </div>

                        <div className='wd-panel-tabs'>
                            {isMobile &&
                                <div
                                    className={classNames('wd-panel-tab', { 'selected': selectedLeftPanel == 'sections' })}
                                    onClick={() => setSelectedLeftPanel('sections')}
                                >
                                    Sections
                                </div>
                            }
                            <div
                                className={classNames('wd-panel-tab', { 'selected': selectedLeftPanel == 'fields' })}
                                onClick={() => setSelectedLeftPanel('fields')}
                            >
                                Fields
                            </div>

                            {!isMobile &&
                                <div
                                    className={classNames('wd-panel-tab', { 'selected': selectedLeftPanel == 'widgets' })}
                                    onClick={() => setSelectedLeftPanel('widgets')}
                                >
                                    Charts
                                </div>
                            }

                        </div>
                        <div className='wd-panel'>
                            {renderLeftPanels()}
                        </div>
                    </div>
                </div>
            }

            <div className={classNames('wd-work-area ')}
                onClick={(e) => {
                    // dont' clear selection when clicking on the resize handler
                    if ((e.target as HTMLDivElement)?.classList?.contains('react-resizable-handle')) {
                        return;
                    }
                    clearSelection();
                }}
                id="widget-designer-working-area"
            >
                <div className="wd-work-area-content-container" style={(uiBG && mode != 'design') ? { backgroundImage: `url(${uiBG})`, backgroundSize: 'cover' } : {}}>
                    <div className={classNames("grid-layout-container", { 'mobile': isMobile })} style={styles}>
                        {
                            isMobile ?
                                <MobilePageLayout
                                    contextData={{}}
                                    designer={designer}
                                    uiProps={uiProps}
                                    uxpContext={uxpContext}
                                    loginLogo={loginLogo}
                                    backgroundImage={backgroundImage}
                                    logo={logo}
                                    backgroundColor={backgroundColor}
                                    bottomNavigationBarBackgroundColor={bottomNavigationBarBackgroundColor}
                                    bottomNavagationBarSelectedItemColor={bottomNavagationBarSelectedItemColor}
                                    bottomNavigationBarUnselectedItemColor={bottomNavigationBarUnselectedItemColor}
                                    hideLucyLogo={hasValue(logo)}
                                    view={view}
                                    zoom={zoom}
                                    appBarHeight={appBarHeight}
                                    appBarBackgroundColor={appBarBackgroundColor}
                                    appBarBackgroundImage={appBarBackgroundImage}
                                    appBarText={appBarText}
                                    textColor={textColor}
                                    tabs={mobileLayout.selectedTab ? mobileLayout?.tabs || [] : uiProps?.tabs || []}
                                    selectedTab={mobileLayout?.selectedTab}
                                    onChangeTab={tab => {
                                        const _tabs: IMobileNavigationTab[] = mobileLayout.selectedTab ? mobileLayout.tabs : uiProps.tabs
                                        if (tab) {
                                            const updated = _tabs.map(t => {
                                                if (t.id == tab.id) return tab
                                                return t
                                            })
                                            setMobileLayout(prev => ({ ...prev, tabs: updated || [], selectedTab: tab, selectedTabProps: tab.props }))
                                            setUiProps(tab.props)
                                        }
                                        else {
                                            setMobileLayout(prev => ({ ...prev, tabs: _tabs || [], selectedTab: null, selectedTabProps: {} }))
                                            setUiProps({ tabs: mobileLayout.tabs })
                                        }
                                    }}
                                    onChangeFields={newFields => {
                                        setUiProps((prev: any) => ({ ...prev, fields: newFields }))

                                        setMobileLayout(prev => {
                                            let _selectedTab = prev.selectedTab
                                            const updatedTabs = prev.tabs.map(t => {
                                                if (t.id == prev.selectedTab?.id) {
                                                    t.props.fields = newFields
                                                    _selectedTab = t
                                                }
                                                return t
                                            })
                                            return {
                                                tabs: updatedTabs,
                                                selectedTab: _selectedTab,
                                                selectedTabProps: _selectedTab.props
                                            }
                                        })
                                    }}
                                />

                                :
                                <GridLayout
                                    className="designer-layout"
                                    cols={numClos}
                                    rowHeight={rowHeight}
                                    width={_width}
                                    isResizable={!locked}
                                    isDraggable={!locked}
                                    autoSize={false}
                                    onLayoutChange={(layout) => {
                                        setWidgetLayout(layout[0])
                                    }}
                                    draggableHandle=".uxp-drag-handler"
                                    layout={[widgetLayout]}
                                >
                                    <div className={`layout-item`}
                                        key={widgetLayout.i}
                                        data-grid={widgetLayout}
                                        data-instance-id={widgetLayout.i}
                                        id="widget-designer-widget-layout-container-rpxgtrs"
                                    >
                                        <div className={`layout-content uxp-drag-handler ${template?.autoHieght ? 'auto-height' : ''}`}  >
                                            {
                                                template
                                                    ?
                                                    // React.createElement(template.template, {
                                                    // designer: mode == 'preview' ? null : designer,
                                                    // uiProps,
                                                    // uxpContext: props.uxpContext,
                                                    // initialSource: props.initialSource
                                                    // })
                                                    React.createElement(template.template as React.ForwardRefExoticComponent<React.RefAttributes<IWidgetTemplateInstanceProps> & IWidgetTemplateProps>,
                                                        {
                                                            designer: mode == 'preview' ? null : designer,
                                                            uiProps,
                                                            uxpContext: props.uxpContext,
                                                            initialSource: props.initialSource,
                                                            ref: templateRef,
                                                            updateWidgetHeight: updateWidgetHeight
                                                        })
                                                    : <div> Please select a widget template</div>
                                            }
                                        </div>
                                    </div>

                                </GridLayout>
                        }
                    </div>
                </div>
                <div className={classNames("editor-controllers-container")}>
                    <div className="left">

                        {!isMobile && <>
                            <div className="size">
                                <Label> W : {widgetLayout.w}</Label>
                                <Label> H : {widgetLayout.h}</Label>
                            </div>

                            <div className="lock"
                                onClick={() => setLocked(prev => !prev)}
                            >
                                <FontAwesomeIcon
                                    icon={['fas', locked ? 'lock-alt' : 'lock-open-alt']}
                                />
                            </div>
                        </>}

                    </div>
                    <div className="right">
                        {(mode === 'design' && template?.toolbar) &&
                            React.createElement(template.toolbar, {
                                designer: designer,
                                uiProps,
                                uxpContext: props.uxpContext,
                                initialSource: props.initialSource,
                            })

                        }


                        {Object.keys(errors).length > 0 &&
                            <ErrorPanel
                                errors={errors}
                                selectedRightPanel={selectedRightPanel}
                                onChangePanel={setSelectedRightPanel}
                                selectedContainerId={containerId}
                            />
                        }

                        {mode === 'design' && <>
                            <div className="undo-redo">
                                <button className="controller"
                                    onClick={() => onUndoRedo(undoManager?.undo())}
                                    disabled={!undoManager.canUndo()}
                                >
                                    <FontAwesomeIcon icon={['fas', 'undo-alt']} />
                                </button>

                                <button className="controller"
                                    onClick={() => onUndoRedo(undoManager?.redo())}
                                    disabled={!undoManager.canRedo()}
                                >
                                    <FontAwesomeIcon icon={['fas', 'redo-alt']} />
                                </button>
                            </div>

                            <div className="zoom">
                                <button className="controller" onClick={() => {
                                    if (isMobile) setZoom(prev => (prev <= 0.5 ? 0.5 : prev -= 0.1))
                                    else setZoom(prev => (prev == 0 ? 0 : prev -= 0.5))
                                }} >
                                    <FontAwesomeIcon icon={['fas', 'minus']} />
                                </button>

                                <button className="controller" onClick={() => {
                                    if (isMobile) setZoom(prev => (prev == 1.5 ? 1.5 : prev += 0.1))
                                    else setZoom(prev => (prev += 0.5))
                                }} >
                                    <FontAwesomeIcon icon={['fas', 'plus']} />
                                </button>
                            </div>
                        </>}

                    </div>
                </div>
            </div>

            {hasRightpanel &&
                <div className='wd-panels-container right'>
                    <div className="wd-panels">

                        <div className='wd-panel-tabs'>
                            <div
                                className={classNames('wd-panel-tab', { 'selected': selectedRightPanel == 'general' })}
                                onClick={() => setSelectedRightPanel('general')}
                            >
                                General
                            </div>

                            <div
                                className={classNames('wd-panel-tab', { 'selected': selectedRightPanel == 'properties' })}
                                onClick={() => setSelectedRightPanel('properties')}
                            >
                                Properties
                            </div>

                        </div>
                        <div className='wd-panel'>
                            {renderRightPanels()}
                        </div>
                    </div>
                </div>
            }

        </div>
    </DragDropContext >
})


interface IErrorPanelProps {
    errors: { [id: string]: IErrorProps },
    selectedRightPanel: PropertyPanelType
    onChangePanel: (panel: PropertyPanelType) => void,
    selectedContainerId: string
}
interface IErrorPanelInstanceProps {
    open: () => void,
    close: () => void
}

const ErrorPanel: React.ForwardRefExoticComponent<React.RefAttributes<IErrorPanelInstanceProps> & IErrorPanelProps> = React.forwardRef((props, ref) => {

    const [show, setShow] = React.useState<boolean>(false)
    const [styles, setStyles] = React.useState<React.CSSProperties>({})

    const buttonRef = React.useRef(null)

    React.useEffect(() => {
        updatePosition()
    }, [])

    React.useEffect(() => {
        updatePosition()
    }, [props])

    React.useEffect(() => {
        setShow(Object.keys.length > 0)
    }, [props.errors])

    React.useEffect(() => {
        updatePosition()
    }, [show])

    function updatePosition() {
        // not a good practice. but when open the designer on a popup in canvas, position is set before the model comes to the full size, so it shows the error message in the middle of the screen. so added a delay here untill the model becomes full size :) 
        setTimeout(() => {
            const buttonDetails = buttonRef.current?.getBoundingClientRect()
            const { top, left, right, bottom, width, height, x, y } = buttonDetails || {}
            const { innerWidth, innerHeight } = window

            const maxWidth = 400
            let hPos = 'left'
            if (left + maxWidth > innerWidth) hPos = 'right'

            let _styles: React.CSSProperties = {
                bottom: document.body.clientHeight - (buttonDetails?.y + window.scrollY) + 20
            }

            if (hPos == 'left') {
                _styles.left = left + width / 2
                _styles.translate = '-50%'
            }
            else _styles.right = Math.max(innerWidth - right, 0)

            setStyles(_styles)
        }, 200);

    }


    function showError(error: IErrorProps) {
        const { id, type, containerId, fieldId, fieldClassName } = error

        console.log('error', error);

        if (type === 'property') {
            if (hasValue(containerId)) {
                // switch to property panel and select the selectable item 
                if (props.selectedContainerId !== containerId) {
                    const ele = document.getElementById(containerId)
                    console.log('container element', ele);

                    if (ele) ele.click()
                }
                else {
                    props.onChangePanel('properties')
                }
            }
        }
        else if (type === 'general') {
            props.onChangePanel('general')
        }

        // wait for panels to switch 
        // ugly hack 
        setTimeout(() => {
            let fields = []
            if (hasValue(fieldId)) {
                const id = bindContainerId(fieldId, type === 'property' ? containerId : null)

                const field = document.getElementById(id)
                console.log('field ', id, field);

                fields = [field]

            } else if (hasValue(fieldClassName)) {
                const className = bindContainerId(fieldClassName, type === 'property' ? containerId : null)

                fields = document.getElementsByClassName(className) as any
            }

            // add error class to each field
            [...fields]?.forEach((field: any) => {
                if (field) field.classList.add('has-error')
            })

            // scroll into the first field
            if (fields?.[0]) {
                fields?.[0].scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                    inline: 'nearest',
                })
            }
        }, 300)
    }


    return <div className='designer-error-panel' onClick={() => { setShow(prev => !prev) }} >
        <div className='designer-errors-button' ref={buttonRef} >
            <FontAwesomeIcon icon={['fas', 'exclamation-circle']} />
        </div>

        <CSSTransition
            in={show}
            timeout={300}
            classNames={'wd-err-fade'}
            unmountOnExit={true}
        >
            <PortalContainer
                hasBackdrop={false}
            >
                <div className='designer-errors-popup-container' style={styles}>
                    <div className='designer-error-container'>
                        {Object.keys(props.errors).map((key: string, i: number) => {

                            const err = props.errors[key]
                            return <div className="error" key={i} onClick={(e) => {
                                e.preventDefault()
                                e.stopPropagation()

                                showError(err)
                            }}
                            >
                                <div className="err">
                                    {err.error}
                                </div>
                                <div className="action" >
                                    <FontAwesomeIcon icon={['fas', 'chevron-double-right']} />
                                </div>
                            </div>
                        })}
                    </div>
                </div>

            </PortalContainer>
        </CSSTransition>
    </div>

})

export default Designer
